/**
 * Shared URL Operations
 * 
 * This module provides common URL operations that can be used
 * by both the main application and the service worker.
 */

import { GOOGLE_SHEETS_CONFIG } from '../../config';

/**
 * Updates the URL with sheet configuration
 * @param {string} spreadsheetId - The Google Sheets spreadsheet ID
 * @param {string} sheetRange - The sheet range
 */
export const updateUrlWithSheetId = (spreadsheetId, sheetRange) => {
  // Skip if no spreadsheet ID or not in browser context
  if (!spreadsheetId || typeof window === 'undefined') return;
  
  const url = new URL(window.location);
  url.searchParams.set('sheetId', spreadsheetId);
  if (sheetRange) {
    url.searchParams.set('sheetRange', sheetRange);
  }
  window.history.pushState({}, '', url);
};

/**
 * Initializes URL with sheet configuration if not already present
 */
export const initializeUrlWithSpreadsheetId = () => {
  // Skip if not in browser context
  if (typeof window === 'undefined') return;
  
  const urlParams = new URLSearchParams(window.location.search);
  if (!urlParams.has('sheetId') && GOOGLE_SHEETS_CONFIG.spreadsheetId) {
    updateUrlWithSheetId(GOOGLE_SHEETS_CONFIG.spreadsheetId, GOOGLE_SHEETS_CONFIG.sheetRange);
  }
};

export default {
  updateUrlWithSheetId,
  initializeUrlWithSpreadsheetId
};
